<template>
  <ModalKim @close="$emit('cancel')" :mood="processed ? 'playful' : 'happy'" :color="processed ? '#4C91FF': '#27C2F2'">
      <template slot="body">
        <transition name="fade">
          <div class="change-email" v-if="!processed">
            <h2>{{ $t('account.changeEmail.title') }}</h2>
            <form @submit.prevent="changeEmail" novalidate autocomplete="off">
              <pk-input v-model="email" :placeholder="$t('account.changeEmail.emailPlaceholder')" type="email" :error="$v.email.$error" />
              <pk-input v-model="password" :placeholder="$t('account.changeEmail.passwordPlaceholder')" type="password" :error="$v.password.$error || errorCode === 403" />

              <error-text :active="!!errorCode || !!$v.$error">
                <span v-if="errorCode === 400" v-t.preserve="'auth.email.error.invalidRequest'" />
                <span v-else-if="[403, 409].includes(errorCode)">{{ $t('account.changeEmail.errors')[errorCode] }}</span>
                <span v-else-if="!!errorCode" v-t.preserve="'auth.email.error.generic'" />
                <span v-else-if="$v.$error && !$v.email.notTheCurrent">{{ $t('account.changeEmail.errors').same }}</span>
                <span v-else-if="$v.email.$error" v-t.preserve="'auth.email.error.email'" />
                <span v-else-if="$v.password.$error" v-t.preserve="'auth.email.error.password'" />
              </error-text>
              <footer>
                <btn :loading="loading" @click="$emit('cancel')" :outlined="true">{{ $t('account.changeEmail.cancel') }}</btn>
                <btn flat :loading="loading" submit>{{ $t('account.changeEmail.cta') }}</btn>
              </footer>
            </form>
          </div>
          <div class="change-email" v-else>
            <h2>{{ $t('account.changeEmail.success') }}</h2>
          </div>
        </transition>
    </template>
  </ModalKim>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import { ACCOUNT_ROUTE } from '@/router/utils'
import validatorMixin from '@/js/mixins/validator'
import enterProcessorMixin from '@/js/mixins/enterProcessor'
import sabAPI from '@/api/sab'

export default {
  name: 'change-email',
  mixins: [validatorMixin, enterProcessorMixin('changeEmail')],
  props: {
    modalActive: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    errorCode: null,
    email: '',
    password: '',
    processed: false
  }),
  validations: {
    email: { required, email, notTheCurrent: (s, vm) => s.toLowerCase() !== vm.credentialKey.toLowerCase() },
    password: { required, minLength: minLength(8) }
  },
  computed: {
    ...mapState({
      credentialKey: state => state.user.credentialKey,
      language: state => state.window.language
    }),
    accountRoute() {
      return ACCOUNT_ROUTE
    }
  },
  methods: {
    ...mapActions({ verifyProfile: 'user/verifyProfile' }),
    async changeEmail() {
      this.errorCode = null
      if (!this.isValid()) {
        return
      }

      this.loading = true
      try {
        await sabAPI.changeEmail(this.email)
        await this.verifyProfile()
        this.processed = true
        // this.$router.previousRoute.name ? this.$router.back() : this.$router.replace({ name: 'account' })
      } catch (err) {
        this.errorCode = err.code
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  justify-content: flex-end;
  .btn {
    margin-left: 1rem;
  }
}
</style>
